export const getPromotionCode = promotion => {
    
    const value = typeof promotion === 'object'
        ? promotion?.code || promotion?.promoCode || promotion?.promotionCode || promotion?.name
        : promotion;

    return String( value || '' ).trim();
};

export const hasPromotionCode = promotion => getPromotionCode( promotion ).length > 0;
